<template>
  <div :class="iconClass" :style="{ width: size + 'px', height: size + 'px', marginRight: '0.3rem' }">
    <slot>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.69444 4.86625C1.66667 6.25 1.66667 6.94938 1.66667 8.125C1.66667 9.34375 1.66667 10.6562 1.66667 11.875C1.66667 13.3666 2.29167 15.1944 3.33333 16.25C4.28731 17.2168 5.41667 17.5 7.22222 17.5C8.99167 17.5 11.0083 17.5 12.7778 17.5C15 17.5 15.8477 17.5 17.0833 16.25C18.319 15 18.3333 13.3666 18.3333 11.875V8.125C18.3333 6.94938 18.3333 6.25 17.3056 4.86625L13.2741 8.94906C12.4056 9.8275 11.2278 10.3216 10 10.3216C8.77222 10.3216 7.59445 9.8275 6.72593 8.94906L2.69444 4.86625ZM3.33333 4.16667L7.83542 8.125C8.35579 8.65281 9.26296 9.16667 10 9.16667C10.737 9.16667 11.6716 8.65281 12.192 8.125L16.6667 4.16667C15.8333 3.33333 15.2211 2.5 12.7778 2.5C11.0083 2.5 8.99167 2.5 7.22222 2.5C5 2.5 4.16667 3.33333 3.33333 4.16667Z"
          fill="currentColor"
        />
      </svg>
    </slot>
  </div>
</template>

<script>
  export default {
    name: 'IconLead',
    props: {
      iconClass: {
        type: String,
        default: '',
      },

      size: {
        type: [Number, String],
        default: '',
      },
    },
  };
</script>

<style scoped>
  /* You can add any additional styles here */
</style>
